import { render } from "./RiskExposureChart.vue?vue&type=template&id=25eda175&ts=true"
import script from "./RiskExposureChart.vue?vue&type=script&lang=ts"
export * from "./RiskExposureChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__